//
import OrdererPriorityModel from '@/models/Warehouse/WhOrdererPriority'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProduct'
import ProviderModel from '@/models/Purchase/PchProvider'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import { required } from '@/services/validations'

//
import headers from './headers'

//
export default (props) => [
    {
        name: 'g_supervisor_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            paramFilter: {
                //permission: true,
            },
            readonly: true,
            rules: [required],
        },
        trigger(ctx) {
            //
            const productsFetch = ({ wh_product_id }) =>
                    ProductModel.append('stocks').find(wh_product_id),
                productsList = ctx.value.wh_selected_products,
                warehouse_id = ctx.value.wh_warehouse_id
            //
            let branch_id = 0
            //
            Promise.all(productsList.map(productsFetch)).then(products => {
                //
                products.forEach(product => {
                    //
                    const productStock = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        if (warehouse.wh_warehouse_id===warehouse_id) branch_id = branch.g_branch_office_id
                                        return warehouse.wh_warehouse_id === warehouse_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )
                    //
                    const productStockBranch = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        return branch.g_branch_office_id === branch_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )

                    //
                    const productSelected = ctx.value.wh_selected_products.find(
                        ({ wh_product_id }) => wh_product_id === product.id
                    )

                    //
                    if (productSelected) {
                        productSelected['stock'] = productStock
                        productSelected['stock_branch'] = productStockBranch
                    }
                })
            })
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'rut',
            itemValue: 'id',
            label: 'Rut',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
        // trigger: props.pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
        trigger: props.pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'select',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            items: props.pch_provider_branch_offices_id_items,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_orderer_priority_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemText: 'priority',
            itemValue: 'id',
            label: 'Prioridad',
            model: OrdererPriorityModel,
            noDataText: 'Sin prioridades.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
            xl3: true,
        },
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Condición de pago',
            model: PaymentConditionModel,
            noDataText: 'Sin condiciones de pago.',
            noObject: true,
            paramSearch: 'type',
            rules: [required],
        },
    },
    {
        name: 'is_exent',
        type: 'switch',
        props: {
            label: 'Es exenta'
        }
    },
    {
        name: 'wh_selected_products',
        type: 'data-table-model',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: headers.product,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                attachParams: {
                    last_provider_code_provider_id: props.pch_provider_id,
                },
                filters: ProductFilters,
                headers: ProductHeaders.exclude(['wh_item_is_inventoriable', 'is_repackaged']),
                noPagination: false,
                mapper: row => {
                    //return newrow last_provider_code
                    //
                    row['g_branch_office_id'] = props.g_branch_office_id
                    row['net_price'] = 0
                    row['quantity'] = 0
                    row['stock'] = row.stock || 1
                    row['wh_product_id'] = row.id
                    row['provider_product_code'] = row.last_provider_code_provider || ''
                    //
                    let branch = row.branch_offices.find(
                        branch =>
                            branch.g_branch_office_id === props.g_branch_office_id
                    )
                    //
                    row.net_price = branch.cost_price || row.net_price
                    //
                    return row
                },
                
                mapperFilter: filters => ({
                    ...filters,
                    product_provider_code: props.pch_provider_id && filters.product_provider_code ? `${pch_provider_id},${filters.product_provider_code}` : undefined
                }),
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la orden',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
        trigger(ctx) {
            //
            const productsFetch = ({ wh_product_id }) =>
                    ProductModel.append('stocks').find(wh_product_id),
                productsList = ctx.value.wh_selected_products,
                warehouse_id = ctx.value.wh_warehouse_id
            //
            let branch_id = 0
            //
            Promise.all(productsList.map(productsFetch)).then(products => {
                //
                products.forEach(product => {
                    //
                    const productStock = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        if (warehouse.wh_warehouse_id===warehouse_id) branch_id = branch.g_branch_office_id
                                        return warehouse.wh_warehouse_id === warehouse_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )
                    //
                    const productStockBranch = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        return branch.g_branch_office_id === branch_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )

                    //
                    const productSelected = ctx.value.wh_selected_products.find(
                        ({ wh_product_id }) => wh_product_id === product.id
                    )

                    //
                    if (productSelected) {
                        productSelected['stock'] = productStock
                        productSelected['stock_branch'] = productStockBranch
                    }
                })
            })
        },
    },
    {
        name: 'comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario',
        },
    },
]
